export default "__VITE_ASSET__3bba47e4__"